import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { RefreshIcon } from '@heroicons/react/outline'
import Login from '../components/auth/Login'
import Footer from '../components/footer/Footer'
import { LayoutFull } from '../layouts'
import { Auth } from 'aws-amplify'
import { resetToken, setToken, setUserEmailAddress } from '../components/auth/store/userSlice'

const PrivateRoute = ({ children, path, exact, }) => {
  // TODO: (change token in 'isSignedIn'?)
  const token = useSelector((state) => state.user.token)
  const dispatch = useDispatch()
  const [isInitiated, setIsInitiated] = React.useState(false)

  React.useEffect(() => {
    if (!token) {
      const getToken = async () => {
        const user = await Auth.currentAuthenticatedUser() || {}

        if (user) {
          const token = user?.signInUserSession?.accessToken?.jwtToken
          const email = user?.attributes?.email

          dispatch(setToken(token))
          dispatch(setUserEmailAddress(email))
        } else {
          console.log('We don’t have user!')
          dispatch(resetToken())
        }
      }
      getToken()
      setIsInitiated(true)
    }
  }, [dispatch, isInitiated, token])

  return (
    !isInitiated
      ? (
          <LayoutFull>
            <>
              <div className="min-h-screen flex items-center justify-center">
                <RefreshIcon className="self-center text-gray-300 flip-horizontal w-16 h-16 bg-transparent rounded-md spin-back" />
              </div>
              <div className="fixed w-full h-16">
                <Footer />
              </div>
            </>
          </LayoutFull>
        )
      : (
        token
          ? (
            <Route path={path} exact={exact}>{children}</Route>
          )
          : (
            <LayoutFull>
              <Login />
            </LayoutFull>
          )
        )
  )
}

PrivateRoute.propTypes = {
  children: PropTypes.any,
  path: PropTypes.string,
  exact: PropTypes.bool,
  isInitiated: PropTypes.bool,
}

export default PrivateRoute
